/*
 * Copyright (C) 2021 Bosch Software Innovations GmbH. All rights reserved.
 */

import * as React from 'react';
import styled from 'styled-components';
import { TableCell, TableCellProps } from '../../atoms';

// Note: The '&&' is a trick to increase specificity of the class.
// This solves the problem that FROK table classes win.

export const CheckboxTableCell = styled(TableCell)`
    && {
        width: 3rem;
    }
`;

export const CheckboxTableHeadCell = styled(CheckboxTableCell)``;

const TextTableCell = styled(TableCell)`
    && {
        width: auto;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const RegularTableCell: React.FC<TableCellProps> = props => {
    if (typeof props.children === 'string' || props.header) {
        return <TextTableCell {...props} />;
    } else {
        return <TableCell {...props} />;
    }
};
